module.exports = __webpack_public_path__ + "img/lg_ring_r_i_1_0.60df935b.png";